import { useCuesDerived } from '@/features/rundown/cue/cue.derived.ts'
import { useColumnsDerived } from '@/features/rundown/column/column.derived.ts'
import { useEffect, useCallback, useMemo } from 'react'
import {
  KeyboardNavigationHandler as KBN,
  keyboardNavigationEventBus,
  KeyboardNavigationEvent,
} from '../../features/keyboard-navigation-handler'
import * as logger from '../../utils/logger'

/**
 * Handles keyboard navigation for cells in a rundown.
 */
export default function KeyboardNavigationHandler() {
  const { visibleColumns: cols } = useColumnsDerived()
  // Include all cues (headings, groups, and cues) so heading titles can be navigation sources
  const { sortedCues: cues } = useCuesDerived()

  const navigationHandler = useMemo(
    () =>
      new KBN({
        cues,
        columns: cols,
      }),
    [cols, cues],
  )

  /**
   * Handles cell keyboard navigation events
   */
  const handleEvent = useCallback(
    (payload) => {
      // const target = calculateNavigationTarget({ cueId, colId, direction })
      //
      // if (!target) return

      const focusPayload = navigationHandler.jump(payload)
      if (!focusPayload) {
        logger.warn('[KeyboardNavigationHandler] Cant find focus target')
        return
      }
      logger.info('[KeyboardNavigationHandler] Navigating to:', focusPayload)
      keyboardNavigationEventBus.emit(
        KeyboardNavigationEvent.FOCUS,
        focusPayload,
      )
    },
    [navigationHandler],
  )

  // Listen for cell keyboard navigation events
  useEffect(() => {
    keyboardNavigationEventBus.on(KeyboardNavigationEvent.JUMP, handleEvent)
    return () =>
      keyboardNavigationEventBus.off(KeyboardNavigationEvent.JUMP, handleEvent)
  }, [handleEvent])

  return null
}
